import Rete from 'rete'
import { nanoid } from 'nanoid/async'

import { App } from '../../App'
import { otnModal } from './otnModal'
import CONST_SOCKET from '../../const/socket'
import { 
  removeNodes,
  addOtnSingleNodeToEditor,
  addNewPostbackNodeToEditor, 
  updateNodeConnections,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { 
    value: otnData,
    isConfirmed: isClickedOkButton,  
  } = await otnModal(oldData, node)

  if (otnData && Object.values(otnData).length > 0) {
    
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
    
    Object.assign(node.data, otnData)

    if ('newOtn' === otnData.otnPostbackIdValue) {
      if (node.outputs instanceof Map) {
        const otnOutput = node.outputs.get(CONST_SOCKET.OTN_OUTPUT)
        if (otnOutput instanceof Rete.Output) {
          if (0 === otnOutput.connections.length) {
            attachOtnSingleAndChildrenToOtnNode(node)
          }
        }
      }
    }

    if ('newOtn' !== otnData.otnPostbackIdValue) {
      if (isClickedOkButton && node.otnPostbackIdValueChangeStatus) {
        if (node.otnSingleNodeChildrenComponents 
          && node.otnSingleNodeChildrenComponents instanceof Map
        ) {
          const nodesList = node.otnSingleNodeChildrenComponents.get('node-id-' + node.id)
          
          if (nodesList) {
            removeNodes(nodesList)
            node.otnSingleNodeChildrenComponents.delete('node-id-' + node.id)
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)
  }


  return false
}

const attachOtnSingleAndChildrenToOtnNode = async (node) => {
  const otnSingleNodePosition = [node.position[0] + 250, node.position[1] + 40]
  const otnSingleNode = await addOtnSingleNodeToEditor(otnSingleNodePosition)

  const nodeList = [otnSingleNode]

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.OTN_OUTPUT),
    otnSingleNode.inputs.get(CONST_SOCKET.OTN_SINGLE_INPUT)
  )

  const newPostbackNodePosition = [node.position[0] + 500, node.position[1] + 40]
  const newPostbackNode = await addNewPostbackNodeToEditor(newPostbackNodePosition)

  nodeList.push(newPostbackNode)

  App.editor.connect(
    otnSingleNode.outputs.get(CONST_SOCKET.OTN_SINGLE_OUTPUT),
    newPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
  )

  const componentsMap = new Map()
  componentsMap.set('node-id-' + node.id, nodeList)
  node.otnSingleNodeChildrenComponents = componentsMap
}